
import './App.css';
import Navbar from './Navbar';


function App() {
  return (
    <div className="App">
      <div className='scroll'>
        <marquee>
        <h>
  <span>Admissions Contact: 9848823332</span>
  <span>| EAPCET / ECET CODE: SRKR</span>
  <span>| M.TECH CODE: SRKR1</span>
  <span>| BBA CODE: 17086</span>
  <span>| Contact Us</span>
</h>

        </marquee>
      </div>
      <Navbar/>
     
  
    </div>
  );
}

export default App;


